module.exports = __webpack_public_path__ + "fonts/Roboto-500-greek43.e58ff47.woff2";